import { useQuery } from '@tanstack/react-query';

import { getTickPercent } from 'api/cex/tickPercent';
import { useTypedSelector } from 'store';
import { ECexName } from 'web3';

export const useTickPercent = () => {
  const pair = useTypedSelector(s => s.pairs.selectedCexPair);

  const query = useQuery({
    queryKey: ['tick-percent', pair?.cex, pair?.token_base.symbol, pair?.token_quote.symbol],
    queryFn: async () => {
      if (!pair) return null as number | null;
      return getTickPercent({
        cex: pair.cex as ECexName,
        base: pair.token_base.symbol,
        quote: pair.token_quote.symbol,
      });
    },
    enabled: Boolean(pair?.id),
    staleTime: 60_000, // 1 min
    gcTime: 5 * 60_000, // 5 min
  });

  return {
    tickPercent: query.data ?? null,
    isLoading: query.isLoading,
  };
};
